import React from 'react';

const LoadingSpinner = () => {
  return (
    <div className="w-100 h-full flex justify-center items-center">
    <div className="w-16 h-16 border-t-4 border-b-4 border-gray-600 rounded-full animate-spin"></div>
  </div>
  );
};

export default LoadingSpinner;
